import React, { useState, useCallback } from "react";
import { Container, Actions, ActionGroup } from "./styles";
import {
  RedButton,
  Button,
  QuietButton,
  BackToLinkButton,
} from "basics/buttons";
import { CheckBoxField } from "basics";
import { FormStatus } from "model/dictionary";

export default function FormToolBar({
  onUpdateForm,
  currentStatus,
  onClose,
  readOnly,
  uploading,
}) {
  const [confirmed, setConfirmed] = useState(false);

  const onHandleConfirmed = (e) => {
    e.preventDefault();

    onUpdateForm(FormStatus.CONFIRMED);
  };

  const onHandleDiscarded = (e) => {
    e.preventDefault();

    onUpdateForm(FormStatus.DISCARDED);
  };

  // Dispara el print dialog del browser. Las reglas @media print del
  // GlobalStyle ocultan automáticamente Header, Hero, Footer, Breadcrumb,
  // y este mismo FormToolBar (no-print).
  const onPrint = useCallback((e) => {
    e.preventDefault();
    window.print();
  }, []);

  const ShowButtons = () => {
    switch (currentStatus) {
      case FormStatus.DRAFT: {
        return (
          <Actions>
            <ActionGroup>
              <Button onClick={onHandleConfirmed} disabled={uploading}>
                {uploading ? "Subiendo archivo…" : "Confirmar postulación"}
              </Button>
              <RedButton type="button" onClick={onHandleDiscarded}>
                Descartar
              </RedButton>
            </ActionGroup>
            <ActionGroup>
              <QuietButton type="button" onClick={onPrint}>
                Imprimir
              </QuietButton>
              <BackToLinkButton to="/">Volver al inicio</BackToLinkButton>
            </ActionGroup>
          </Actions>
        );
      }
      case "view": {
        return (
          <Actions>
            <ActionGroup>
              <QuietButton type="button" onClick={onPrint}>
                Imprimir
              </QuietButton>
            </ActionGroup>
            <ActionGroup>
              {onClose ? (
                <Button type="button" onClick={onClose}>
                  Cerrar
                </Button>
              ) : (
                <BackToLinkButton to="/">Volver</BackToLinkButton>
              )}
            </ActionGroup>
          </Actions>
        );
      }
      default: {
        return (
          <Actions>
            <ActionGroup>
              <Button disabled={!confirmed || uploading}>
                {uploading ? "Subiendo archivo…" : "Enviar postulación"}
              </Button>
              <QuietButton type="button" onClick={onPrint}>
                Imprimir
              </QuietButton>
            </ActionGroup>
            <ActionGroup>
              <BackToLinkButton to="/">Volver al inicio</BackToLinkButton>
            </ActionGroup>
          </Actions>
        );
      }
    }
  };

  return (
    <Container className="no-print">
      {(!currentStatus || currentStatus === FormStatus.PREVIEW) && (
        <CheckBoxField
          id="Confirmation"
          showRow={true}
          secondary="Declaro que los datos proporcionados en este formulario son veraces y acepto íntegramente los términos y condiciones establecidos en el "
          link="Reglamento de los Premios Sadosky"
          onChange={() => setConfirmed(!confirmed)}
          readOnly={readOnly}
        />
      )}

      <ShowButtons />
    </Container>
  );
}
